module.exports = __webpack_public_path__ + "img/19.aa52f89a.png";